import React, { useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { Text } from 'rebass'

// components
import Row from '../../../components/Row'

const CardImage = styled.div<{ width?: string, height?: string, border?: string, row?: boolean, iconSize?: string}>`
  position: relative;
  width: ${({ width }) => width ? width : '220px'};
  height: ${({ height }) => height ? height : '220px'};
  border-radius: ${({ border }) => border ? border : '100%'};
  box-sizing: border-box;
  cursor: pointer;
  ${({ theme, width }) => theme.mediaWidth.upToMedium`
    max-width: 100%;
    ${width && width === '383px' &&`
      height: 283px;
    `}
  `}
  .bg-image {
    display: flex;
    flex-direction: ${({ row }) => row ? 'row' : 'column'};
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    background: ${({ theme }) => theme.bsBg32};
    border: 0.733333px dashed ${({ theme }) => theme.bsBorder7};
    border-radius: ${({ border }) => border ? border : '100%'};
  }
  .cover-image {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    border-radius: ${({ border }) => border ? border : '100%'};
  }
  .add-img {
    width: ${({ iconSize }) => iconSize ? iconSize : '40px'}!important;
    height: ${({ iconSize }) => iconSize ? iconSize : '40px'}!important;
    border: 100%;
  }
  .cover {
    flex-direction: ${({ row }) => row ? 'row' : 'column'};
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0px;
    right: 0;
    border-radius: ${({ border }) => border ? border : '100%'};
    transition: background .2s linear;
    z-index: 1;
    cursor: pointer;
    .support {
      width: auto;
      color: ${({ theme }) => theme.white};
      opacity: 0;
      transition: opacity .2s linear;
    }
    .add-img {
      opacity: 0;
      transition: opacity .2s linear;
    }
  }
  &:hover {
    .cover {
      background: rgba(0, 0, 0, 0.45);
      .support {
        opacity: 1;
      }
      .add-img {
        opacity: 1;
      }
    }
  }
`

export default function NewUpLoadFiles({ info, type, uploadImg, uploadIdImg, accept, cssDetail }: {info: any, type: string, uploadImg: (type: any) => void, uploadIdImg: (event: any, type: any) => void, accept?: string, cssDetail?: any }) {
  const theme = useContext(ThemeContext)

  return (
    <CardImage width={cssDetail?.width} height={cssDetail?.height} border={cssDetail?.border} row={cssDetail?.row} iconSize={cssDetail?.iconSize}>
      {
        info.text ? <>
          <img className="cover-image" src={info.text} alt="" />
          <Row className="cover" onClick={() => !info.loading && uploadImg(type)}>
            <img className="add-img" src="images/nft/add_white.png" alt="" />
            <Text className="support" fontSize={cssDetail?.fontSize || 14} color={theme.bsText24} fontFamily="Roboto-Medium" margin={cssDetail?.textMargin}>
              { cssDetail?.title }
            </Text>
          </Row>
        </> : (
          <div className="bg-image" onClick={() => !info.loading && uploadImg(type)}>
            <img className="add-img" src="images/nft/add.png" alt="" />
            <Text fontSize={cssDetail?.fontSize || 14} color={theme.bsText24} fontFamily="Roboto-Medium" margin={cssDetail?.textMargin}>
              { cssDetail?.title }
            </Text>
          </div>
        )
      }
      <input
        type="file"
        accept={accept ? accept : '.jpg, .png, .jpeg, .gif'}
        id={type}
        className="inputFile"
        onChange={event => {
          uploadIdImg(event, type)
        }}
      />
    </CardImage>
  )
}
